// import React, { useState } from 'react';
// import { useGetCourseStudentsQuery } from '../redux/apiSlice';

// const StudentsTab = ({ courseId }) => {
//   const [showSuccessToast, setShowSuccessToast] = useState(false);
//   const [showErrorToast, setShowErrorToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');

//   // Use the course students query
//   const { 
//     data: studentsData, 
//     isLoading, 
//     isError, 
//     error,
//     refetch 
//   } = useGetCourseStudentsQuery(courseId, {
//     skip: !courseId // Skip if no courseId provided
//   });

//   // Show success toast
//   const showSuccess = (message) => {
//     setToastMessage(message);
//     setShowSuccessToast(true);
//     setTimeout(() => setShowSuccessToast(false), 5000);
//   };

//   // Show error toast
//   const showError = (message) => {
//     setToastMessage(message);
//     setShowErrorToast(true);
//     setTimeout(() => setShowErrorToast(false), 5000);
//   };

//   // Extract students from API response
//   const students = studentsData?.students || [];
//   const totalStudents = studentsData?.totalStudents || 0;

//   // Log API response for debugging
//   React.useEffect(() => {
//     if (studentsData) {
//       console.log('✅ Students data fetched successfully:', studentsData);
//       console.log('📊 Total students:', totalStudents);
//       console.log('👥 Students array:', students);
//     }
//   }, [studentsData, totalStudents, students]);

//   // Log errors for debugging
//   React.useEffect(() => {
//     if (isError) {
//       console.error('❌ Failed to fetch students:', error);
//       showError('Failed to load student data. Please try again.');
//     }
//   }, [isError, error]);

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount || 0);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const handleExportList = () => {
//     console.log('📤 Exporting student list for course:', courseId);
//     // This would typically call an export API
//     // For now, we'll simulate the action
//     showSuccess('Export feature coming soon!');
//   };

//   const handleRetry = () => {
//     console.log('🔄 Retrying to fetch students data...');
//     refetch();
//   };

//   // Calculate total revenue from students
//   const totalRevenue = students.reduce((sum, student) => sum + (student.purchaseAmount || 0), 0);

//   // Calculate total discounts
//   const totalDiscounts = students.reduce((sum, student) => sum + (student.discount || 0), 0);

//   // Count students with discounts
//   const studentsWithDiscount = students.filter(student => student.discount > 0).length;

//   const getPriceDisplay = (student) => {
//     if (student.discount > 0) {
//       return (
//         <div className="flex flex-col">
//           <div className="flex items-center space-x-2">
//             <span className="text-sm font-semibold text-gray-900">
//               {formatCurrency(student.purchaseAmount)}
//             </span>
//             <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
//               {student.discountPercentage || Math.round((student.discount / (student.purchaseAmount + student.discount)) * 100)}% OFF
//             </span>
//           </div>
//           <span className="text-xs text-gray-500 line-through">
//             {formatCurrency(student.originalPrice || (student.purchaseAmount + student.discount))}
//           </span>
//         </div>
//       );
//     }
    
//     return (
//       <span className="text-sm font-semibold text-gray-900">
//         {formatCurrency(student.purchaseAmount)}
//       </span>
//     );
//   };

//   return (
//     <div>
//       {/* Success Toast */}
//       {showSuccessToast && (
//         <div className="fixed top-4 right-4 z-50 animate-fade-in">
//           <div className="bg-green-500 text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3">
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <span>{toastMessage}</span>
//           </div>
//         </div>
//       )}

//       {/* Error Toast */}
//       {showErrorToast && (
//         <div className="fixed top-4 right-4 z-50 animate-fade-in">
//           <div className="bg-red-500 text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3">
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <span>{toastMessage}</span>
//           </div>
//         </div>
//       )}

//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h3 className="text-xl font-bold text-gray-900">Enrolled Students ({totalStudents})</h3>
//           <p className="text-gray-600 text-sm mt-1">
//             Total Revenue: {formatCurrency(totalRevenue)}
//           </p>
//         </div>
//         <button 
//           onClick={handleExportList}
//           className="px-4 py-2 bg-green-500 text-white rounded-xl font-semibold transition-all duration-300 hover:bg-green-600 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
//           disabled={isLoading || students.length === 0}
//         >
//           {isLoading ? 'Loading...' : 'Export List'}
//         </button>
//       </div>
      
//       {isLoading ? (
//         <div className="flex justify-center items-center py-12">
//           <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
//           <span className="ml-3 text-gray-600">Loading students data...</span>
//         </div>
//       ) : isError ? (
//         <div className="text-center py-12">
//           <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
//             <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//           </div>
//           <h3 className="text-lg font-semibold text-gray-900 mb-2">Failed to load students</h3>
//           <p className="text-gray-600 mb-4">
//             {error?.data?.message || 'Unable to load student data. Please try again.'}
//           </p>
//           <button
//             onClick={handleRetry}
//             className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
//           >
//             Retry
//           </button>
//         </div>
//       ) : students.length === 0 ? (
//         <div className="text-center py-12">
//           <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
//             <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
//             </svg>
//           </div>
//           <h3 className="text-lg font-semibold text-gray-900 mb-2">No students enrolled yet</h3>
//           <p className="text-gray-600">Students who enroll in your course will appear here</p>
//         </div>
//       ) : (
//         <>
//           <div className="overflow-hidden rounded-xl border border-gray-200">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Student Name
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Enrolled Date
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Purchase Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {students.map((student) => (
//                   <tr key={student.id} className="hover:bg-gray-50 transition-colors duration-200">
//                     {/* Student Name Column */}
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="text-sm font-medium text-gray-900">
//                         {student.name || `Student ${student.id}`}
//                       </div>
//                       {student.email && (
//                         <div className="text-xs text-gray-500 mt-1">
//                           {student.email}
//                         </div>
//                       )}
//                     </td>
                    
//                     {/* Enrolled Date Column */}
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="text-sm text-gray-900">
//                         {formatDate(student.enrolledDate || student.createdAt)}
//                       </div>
//                     </td>
                    
//                     {/* Purchase Amount Column */}
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       {getPriceDisplay(student)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Summary Statistics */}
//           <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
//             <div className="bg-white rounded-lg p-4 border border-gray-200">
//               <div className="text-2xl font-bold text-gray-900">
//                 {formatCurrency(totalRevenue)}
//               </div>
//               <div className="text-sm text-gray-600">Total Revenue</div>
//             </div>
            
//             <div className="bg-white rounded-lg p-4 border border-gray-200">
//               <div className="text-2xl font-bold text-gray-900">
//                 {formatCurrency(totalDiscounts)}
//               </div>
//               <div className="text-sm text-gray-600">Total Discounts Given</div>
//             </div>
            
//             <div className="bg-white rounded-lg p-4 border border-gray-200">
//               <div className="text-2xl font-bold text-gray-900">
//                 {studentsWithDiscount}
//               </div>
//               <div className="text-sm text-gray-600">Students with Discount</div>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default StudentsTab;
import React, { useState, useEffect } from 'react';

const StudentsTab = ({ studentsData, formatCurrency, onPageChange, currentPage }) => {
  const [notification, setNotification] = useState(null);
  const { students = [], pagination = {}, isLoading, isError, onRetry } = studentsData;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const handleExportList = () => {
    console.log('📤 Exporting student list...');
    setNotification({
      type: 'info',
      message: 'Export feature coming soon!'
    });
    
    setTimeout(() => setNotification(null), 3000);
  };

  const getPriceDisplay = (pricePaid) => {
    if (!pricePaid) return 'Free';
    return formatCurrency(pricePaid);
  };

  // Calculate statistics
  const calculateStats = () => {
    let totalRevenue = 0;
    
    students.forEach(student => {
      totalRevenue += student.pricePaid || 0;
    });
    
    return { totalRevenue };
  };

  const stats = calculateStats();

  // Render pagination
  const renderPagination = () => {
    if (!pagination.totalPages || pagination.totalPages <= 1) return null;

    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, (pagination.page || 1) - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(pagination.totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`px-3 py-1 rounded-lg text-sm font-medium transition-all duration-300 hover:scale-110 ${
            (pagination.page || 1) === i
              ? 'bg-green-500 text-white shadow-md'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="flex justify-center items-center space-x-2 mt-6">
        <button
          onClick={() => onPageChange((pagination.page || 1) - 1)}
          disabled={pagination.page === 1}
          className={`px-3 py-1 rounded-lg text-sm font-medium transition-all duration-300 hover:scale-110 ${
            pagination.page === 1
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Previous
        </button>

        {pages}

        <button
          onClick={() => onPageChange((pagination.page || 1) + 1)}
          disabled={!pagination.hasNext}
          className={`px-3 py-1 rounded-lg text-sm font-medium transition-all duration-300 hover:scale-110 ${
            !pagination.hasNext
              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Next
        </button>
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin"></div>
        <span className="ml-3 text-gray-600">Loading students data...</span>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Failed to load students</h3>
        <p className="text-gray-600 mb-4">Unable to load student data. Please try again.</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-green-500 text-white rounded-lg font-semibold hover:bg-green-600 transition-all duration-300"
          >
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div>
      {notification && (
        <div className="mb-6">
          <div className={`rounded-lg p-4 ${
            notification.type === 'info' ? 'bg-blue-50 border border-blue-200 text-blue-800' :
            'bg-green-50 border border-green-200 text-green-800'
          }`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                {notification.type === 'info' ? 'ℹ️' : '✅'}
                <span className="ml-2">{notification.message}</span>
              </div>
              <button onClick={() => setNotification(null)} className="text-gray-500 hover:text-gray-700">
                ✕
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-xl font-bold text-gray-900">
            Enrolled Students ({pagination.total || students.length})
          </h3>
          {students.length > 0 && (
            <p className="text-gray-600 text-sm mt-1">
              Total Revenue: {formatCurrency(stats.totalRevenue)}
            </p>
          )}
        </div>
        <button 
          onClick={handleExportList}
          className="px-4 py-2 bg-green-500 text-white rounded-xl font-semibold transition-all duration-300 hover:bg-green-600 hover:scale-105"
        >
          Export List
        </button>
      </div>
      
      {students.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No students enrolled yet</h3>
          <p className="text-gray-600">Students who enroll in your course will appear here</p>
        </div>
      ) : (
        <>
          <div className="overflow-hidden rounded-xl border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Student
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Enrolled Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Price Paid
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {students.map((student) => (
                  <tr key={student.id} className="hover:bg-gray-50 transition-colors duration-200">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center mr-3">
                          <span className="text-white text-xs font-bold">
                            {student.name?.charAt(0)?.toUpperCase() || '?'}
                          </span>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-gray-900">
                            {student.name}
                          </div>
                          {student.email && (
                            <div className="text-xs text-gray-500 mt-0.5">
                              {student.email}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {formatDate(student.enrolledDate)}
                      </div>
                    </td>
                    
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-semibold text-gray-900">
                        {getPriceDisplay(student.pricePaid)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {renderPagination()}

          {/* Statistics Cards */}
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white rounded-lg p-4 border border-gray-200">
              <div className="text-2xl font-bold text-gray-900">
                {pagination.total || students.length}
              </div>
              <div className="text-sm text-gray-600">Total Students</div>
            </div>
            
            <div className="bg-white rounded-lg p-4 border border-gray-200">
              <div className="text-2xl font-bold text-gray-900">
                {formatCurrency(stats.totalRevenue)}
              </div>
              <div className="text-sm text-gray-600">Total Revenue</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StudentsTab;